export default "__VITE_ASSET__DMyLu_ep__"